import {Component, OnInit, Injector, AfterViewInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {ModalBaseComponent} from '../modal-base-component';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {DefaultService} from "../../../../gen/swagger-api/api/default.service";
import {AUDITTRAILINFO} from "../../../../gen/swagger-api";

@Component({
  selector: 'app-subscription-pool-mno-audit',
  templateUrl: './subscription-pool-mno-audit.component.html',
  styleUrls: ['./subscription-pool-mno-audit.component.css']
})
export class SubscriptionPoolMnoAuditComponent extends ModalBaseComponent implements OnInit {

  auditTrails: Array<AUDITTRAILINFO>;
  eid: string;
  downloadJsonHref: SafeUrl;

  constructor(private inject: Injector,
              private _bsModalRef: BsModalRef,
              private defaultService: DefaultService,
              private sanitizer: DomSanitizer) {
    super(inject);
  }

  ngOnInit(): void {
    this.defaultService.cardsEidAuditGet(this.eid).subscribe(response => {
      this.auditTrails = response;
      this.generateDownloadJsonUri();
    });
  }

  public closeModal(): void {
    this._bsModalRef.hide();
  }

  public refresh(): void {
    this.defaultService.cardsEidAuditGet(this.eid).subscribe(response => {
      this.auditTrails = response;
    });
  }

  generateDownloadJsonUri() {
    var theJSON = JSON.stringify(this.auditTrails);
    var uri = this.sanitizer.bypassSecurityTrustUrl("data:text/json;charset=UTF-8," + encodeURIComponent(theJSON));
    this.downloadJsonHref = uri;
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/subscription-pool-mno-audit/subscription-pool-mno-audit.component.ts